/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Top_Products_TitleInputs */

const vi_report_top_products_title = /** @type {(inputs: Report_Top_Products_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top 10 sản phẩm`)
};

/**

* @param {Report_Top_Products_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_top_products_title = /** @type {((inputs?: Report_Top_Products_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Top_Products_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_top_products_title(inputs)
});